import { render, staticRenderFns } from "./ModalGapsInCare.vue?vue&type=template&id=21af764a&scoped=true"
import script from "./ModalGapsInCare.vue?vue&type=script&lang=js"
export * from "./ModalGapsInCare.vue?vue&type=script&lang=js"
import style0 from "./ModalGapsInCare.vue?vue&type=style&index=0&id=21af764a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21af764a",
  null
  
)

export default component.exports